module.exports = __webpack_public_path__ + "static/media/logo.1e80fb3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/assets/logo.svg
// module id = ./src/App/assets/logo.svg
// module chunks = 0